export const MENU_ITEM_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.MenuItemElement';
